import { ColumnConfig } from "../types";

export const DEFAULT_PROFILE_TABLE_COLUMN_CONFIG: ColumnConfig[] = [
  { key: 'idPassport', label: 'ID / Passport', sizeFactor: 1 },
  { key: 'name', label: 'Name', sizeFactor: 1 },
  { key: 'surname', label: 'Surname', sizeFactor: 1 },
]